module.exports = __webpack_public_path__ + "img/xcx.0d85fd29.jpg";